<template>
	<div class="zyro-range">
		<div class="zyro-range__input-wrapper">
			<input
				ref="rangeInput"
				v-bind="$attrs"
				type="range"
				v-on="$listeners"
			>
			<span
				class="zyro-range__value z-body-small z-body-small--strong"
				v-text="`${$attrs.value} ${units}`"
			/>
		</div>
	</div>
</template>

<script>
export default {
	inheritAttrs: false,
	props: {
		units: {
			type: String,
			default: 'px',
		},
	},
};
</script>

<style lang="scss" scoped>
.zyro-range {
	width: 100%;

	&__input-wrapper {
		display: flex;
		align-items: center;
		width: 100%;
	}

	&__value {
		flex: 0 0 auto;
		padding: 0 16px;
		text-align: center;
	}
}
// Styling Cross-Browser Compatible Range Inputs with Sass
// Github: https://github.com/darlanrod/input-range-sass
// Author: Darlan Rod https://github.com/darlanrod
// Version 1.5.2
// MIT License

$track-color: $grey-300 !default;
$thumb-color: $light !default;

$thumb-radius: 23px !default;
$thumb-height: 23px !default;
$thumb-width: 23px !default;
$thumb-shadow-size: 6px !default;
$thumb-shadow-blur: 14px !default;
$thumb-shadow-color: rgba(0, 0, 0, 0.1) !default;
$thumb-border-width: 1px !default;
$thumb-border-color: $grey-300 !default;

$track-width: 100% !default;
$track-height: 3px !default;
$track-shadow-size: 0 !default;
$track-shadow-blur: 0 !default;
$track-shadow-color: rgba(0, 0, 0, 0) !default;
$track-border-width: 0 !default;
$track-border-color: #cfd8dc !default;

$track-radius: 3px !default;
$contrast: 3% !default;

$ie-bottom-track-color: darken($track-color, $contrast) !default;

@mixin shadow($shadow-size, $shadow-blur, $shadow-color) {
	box-shadow: 0 $shadow-size $shadow-blur $shadow-color;
}

@mixin track {
	width: $track-width;
	height: $track-height;
	cursor: default;
	transition: all 0.2s ease;
}

@mixin thumb {
	@include shadow($thumb-shadow-size, $thumb-shadow-blur, $thumb-shadow-color);

	box-sizing: border-box;
	width: $thumb-width;
	height: $thumb-height;
	cursor: col-resize;
	background: $thumb-color;
	border: $thumb-border-width solid $thumb-border-color;
	border-radius: $thumb-radius;
}
/* stylelint-disable no-descending-specificity */

[type='range'] {
	width: $track-width;
	margin: $thumb-height / 2 0;
	background: transparent;
	-webkit-appearance: none;

	&::-moz-focus-outer {
		border: 0;
	}

	&::-webkit-slider-runnable-track {
		@include track;
		@include shadow($track-shadow-size, $track-shadow-blur, $track-shadow-color);

		background: $track-color;
		border: $track-border-width solid $track-border-color;
		border-radius: $track-radius;
	}

	&::-webkit-slider-thumb {
		@include thumb;

		margin-top: ((-$track-border-width * 2 + $track-height) / 2 - $thumb-height / 2);
		-webkit-appearance: none;
	}

	&::-moz-range-track {
		@include shadow($track-shadow-size, $track-shadow-blur, $track-shadow-color);
		@include track;

		height: $track-height / 2;
		background: $track-color;
		border: $track-border-width solid $track-border-color;
		border-radius: $track-radius;
	}

	&::-moz-range-thumb {
		@include thumb;
	}

	&::-ms-track {
		@include track;

		color: transparent;
		background: transparent;
		border-color: transparent;
		border-width: ($thumb-height / 2) 0;
	}

	&::-ms-fill-lower {
		@include shadow($track-shadow-size, $track-shadow-blur, $track-shadow-color);

		background: $ie-bottom-track-color;
		border: $track-border-width solid $track-border-color;
		border-radius: ($track-radius * 2);
	}

	&::-ms-fill-upper {
		@include shadow($track-shadow-size, $track-shadow-blur, $track-shadow-color);

		background: $track-color;
		border: $track-border-width solid $track-border-color;
		border-radius: ($track-radius * 2);
	}

	&::-ms-thumb {
		@include thumb;

		margin-top: $track-height / 4;
	}

	&:disabled {
		&::-webkit-slider-thumb,
		&::-moz-range-thumb,
		&::-ms-thumb,
		&::-webkit-slider-runnable-track,
		&::-ms-fill-lower,
		&::-ms-fill-upper {
			cursor: not-allowed;
		}
	}

	&:focus {
		outline: 0;

		&::-webkit-slider-runnable-track {
			background: lighten($track-color, $contrast);
		}

		&::-ms-fill-lower {
			background: $track-color;
		}

		&::-ms-fill-upper {
			background: lighten($track-color, $contrast);
		}
	}
}
/* stylelint-enable no-descending-specificity */

</style>
